export default __webpack_public_path__ + "locales/sr-Latn-RS/Common.json?hash=9767ef0be874428f5d8634a3d2f6810d";